<template>  
    <div class="result-controls">
        <div class="controls-top container">
            <div class="result-info">
                <div><strong class="result-num">{{resultCnt}}개</strong>의 검색 결과</div>
            </div>
            <div class="position-relative" v-if="resultCnt != 0">
                <button @click.prevent="showFilterSelect" class="btn-filter-select mobile-only" aria-label="정렬 기준 선택"></button>
                <ul class="result-filter">
                    <li>
                        <button type="button" class="filter-item" value="POPULAR" :class="{'active': this.order === 'POPULAR'}" v-on:click="filterClick($event)">
                            인기 상품 순
                        </button>
                    </li>
                    <li>
                        <button type="button" class="filter-item" value="HIGH_PRC" :class="{'active': this.order === 'HIGH_PRC'}" v-on:click="filterClick($event)">
                            높은 가격 순
                        </button>
                    </li>
                    <li>
                        <button type="button" class="filter-item" value="LOW_PRC" :class="{'active': this.order === 'LOW_PRC'}" v-on:click="filterClick($event)">
                            낮은 가격 순
                        </button>
                    </li>
                    <li>
                        <button type="button" class="filter-item" value="DISCOUNT_RATIO" :class="{'active': this.order === 'DISCOUNT_RATIO'}" v-on:click="filterClick($event)">
                            할인율 순
                        </button>
                    </li>
                </ul>
            </div>
        </div>
        <!-- 모바일용 필터 셀렉트 옵션 영역 -->
        <div role="dialog" class="controls-bottom mobile-toast-popup" :class="{'active': isVisibleMobilePopup}">
            <div class="opacity-bg" @click.prevent="closeResultFilter"></div>
            <div class="result-filter toast-layout">
                <div class="toast-name">정렬</div>
                <ul>
                    <li>
                        <button type="button" class="filter-item" value="POPULAR" :class="{'active': this.order === 'POPULAR'}" v-on:click="filterClick($event)">
                            인기 상품 순
                        </button>
                    </li>
                    <li>
                        <button type="button" class="filter-item" value="HIGH_PRC" :class="{'active': this.order === 'HIGH_PRC'}" v-on:click="filterClick($event)">
                            높은 가격 순
                        </button>
                    </li>
                    <li>
                        <button type="button" class="filter-item" value="LOW_PRC" :class="{'active': this.order === 'LOW_PRC'}" v-on:click="filterClick($event)">
                            낮은 가격 순
                        </button>
                    </li>
                    <li>
                        <button type="button" class="filter-item" value="DISCOUNT_RATIO" :class="{'active': this.order === 'DISCOUNT_RATIO'}" v-on:click="filterClick($event)">
                            할인율 순
                        </button>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import {eventBus} from '@/event/index.js';
import { mapState } from 'vuex';

export default {
    props: {    
        keyword: {
            type: String
        },
    },
    
    data() {
        return {
            // resultCnt: null,
            isVisibleMobilePopup: false,
            order: 'POPULAR',
        }
    },

    created() {
        // eventBus.$off('resultCnt')
        // eventBus.$on('resultCnt', this.getResultCnt)
    },

    mounted() {
        // 할인율 더보기 시 디폴트로 할인율 순으로 체크 되어서 조회
        if(this.keyword === '할인율베스트상품') {
            this.order = 'DISCOUNT_RATIO';
            eventBus.$emit('orderDiscountRatio', this.keyword);
        }
    },

    computed: {
		...mapState({
            resultCnt: state => state.resultCnt,
        }),	
	},

    watch: {
        
    },

    methods: {
        // 관심상품 검색결과 개수
        // getResultCnt(value) {
        //     this.resultCnt = value   
        //     console.log("ResultControl ResultCnt : " + this.resultCnt)               
        // },

        //필터 변경 함수
        filterClick(event) {
            this.order = event.currentTarget.value;

            if(this.$route.name === 'explore') {
                eventBus.$emit('mainOrder', this.order);
            } else {
                eventBus.$emit('order', this.order);
            }
            
            this.closeResultFilter();
        },

        // 모바일용 필터 선택시
        showFilterSelect() {
            this.isVisibleMobilePopup = true;
        },
        
        //정렬 필터 요소 외 외부영역 클릭 시
        closeResultFilter() {
            this.isVisibleMobilePopup = false;
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/util/resultcontrol.scss';
</style>